module.exports = __webpack_public_path__ + "src/img/barChart.903e59675027c0f0689337399ca4fd13.png";